
import React, { Component } from 'react';

import './../../../../scss/App.scss';
import { trackingWrapper } from '../../../utils/analytics';

class GiveUpBtn extends Component {
	constructor(props){
		super(props);

		this.state = {
			expanded : false,
			closeOut : false
		};

		this.handleGiveUpClick = this.handleGiveUpClick.bind(this);
		this.handleNoClick = this.handleNoClick.bind(this);
		this.handleYesClick = this.handleYesClick.bind(this);
	}

	componentDidMount(){
		//console.log("GiveUpBtn :: componentDidMount");
	}

	handleGiveUpClick(){
		this.setState({
			expanded : true
		});
	}

	handleNoClick(){
		this.setState({
			expanded : false
		});
	}

	handleYesClick(){

		// tracking
		trackingWrapper('event', 'ASgame-answer-reveal', {'event_category':'america-says-game'});

		this.setState({
			closeOut : true
		});

		this.props.handleGiveUp();
	}

	render(){

		const expanded = (this.state.expanded) ? " expand" : "" ;
		const show = (this.props.show && !this.state.closeOut) ? " show" : "";

		return(
			<div className={"giveUpBtn" + expanded + show}>
				<div className="yesBtn" onClick={this.handleYesClick} onMouseOver={() => window.sounds.buttonHover.play()}>YES</div>
				<div className="noBtn" onClick={() => this.handleNoClick()} onMouseOver={() => window.sounds.buttonHover.play()}>NO</div>
				<div className="confirmLabel">SURE?</div>
				<div className="giveUpLabel" onClick={() => this.handleGiveUpClick()}>REVEAL?</div>
				<div className="warning">(this will end the round & reveal all remaining answers)</div>
			</div>
		);
	}
}

export default GiveUpBtn;


// WEBPACK FOOTER //
// ./src/js/components/gamepage/game/GiveUpButton.js